import React, { Component } from 'react';
import { BaseTemplate } from './BaseTemplate.js';
import $ from 'jquery';
import {Bar} from 'react-chartjs-2';

export class ApiTesting extends Component {
  constructor(props) {
    super(props);

    this.changeApi = this.changeApi.bind(this);
    this.changePar = this.changePar.bind(this);
    this.callUrl = this.callUrl.bind(this);
    this.state = { par: 0, api: '', user: 'testuniweb', pass: 'uw-1317', apiResult: '' };

  }

  changeApi(e) {
    this.setState({ api: e.target.value });
  }

  changePar(e) {
    this.setState({ par: e.target.value });
  }

  testCallback(a) {
    console.log(a);
  }

  callUrl(e) {
    e.preventDefault();

    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'CreateTunnel',
        DeviceID: 175,
      }),
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        // LISTA DISPOSITIVI COLLEGATI
        /*
        $.ajax({
          method: 'GET',
          url: res.Tunnel.URL + '/zigbee/json',
          headers: {
            'x-session': this.props.token,
          },
          dataType: 'json',
          xhrFields: {
            withCredentials: true
          },
          success: (res) => {
            console.log(res);
          },
          error: (httpReq, status, exception) => {
            console.log(httpReq);
            console.log(status);
            console.log(exception);
          },
        });
        */

        // GAS: 00:50:43:C9:A3:33:1C:94
        //{"Action":"GetStoredData","DeviceID":140,"From":1515538800,"To":1526421600,"Offset":0,"Queue":100}:
        $.ajax({
          method: 'POST',
          url: 'https://sparkjvm.com/cloud/json',
          headers: {
            'x-session': this.props.token,
          },
          dataType: 'json',
          data: JSON.stringify({
            Action: 'GetStoredData',
            DeviceID: 175,
            From: 1527582600,
            //To: 1526503063,
            Offset: 0,
            Queue: parseInt(this.state.par, 10),
            //XPath: "Nodes[IEEEAddress='00:50:C2:C7:02:BE:95:89']"
          }),
          xhrFields: {
            withCredentials: true
          },
          success: (res) => {
            console.log(res);
          },
          error: (httpReq, status, exception) => {
            console.log(httpReq);
            console.log(status);
            console.log(exception);
          },
        });
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  render() {
    this.data = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: 'rgb(255, 99, 132)',
            borderColor: 'rgb(255, 99, 132)',
            data: [0, 10, 5, 2, 20, 30, 45],
          },
          {
            label: "My Second dataset",
            backgroundColor: 'rgb(0, 99, 132)',
            borderColor: 'rgb(255, 99, 132)',
            data: [15, 30, 1, 9, 6, 60, 15],
          },
        ]
    };

    return (
      <BaseTemplate>
        <Bar data={ this.data } />

        <div className="api">
          <header className="api__header">
            <h1>Chiamata API Gemino</h1>
          </header>
          <div className="api__content">
            <input id="par" onChange={ this.changePar } value={ this.state.par } type="number" /><br />
            <select onChange={ this.changeApi }>
              <option value="">-- Seleziona API --</option>
              <option value="GetDevices">GetDevices - lista di gateway associati</option>
              <option value="CreateTunnel">CreateTunnel - crea un tunnel tra il cloud ed il gateway</option>
            </select><br />
            <button onClick={ this.callUrl }>Esegui chiamata</button>
          </div>
          <div className="api-result">{ this.state.apiResult }</div>
        </div>
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ApiTesting.js